import { akeronService } from "./akeronService";

const section = "Company";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return akeronService.make_get_request(`${section}/ListCompany/${name}/${from}/${limit}/${active}`, {}).then((response) => {
    let result = {
      quantity: response.quantity || 0,
      list: response.companies || response.list || [],
    };
    return result;
  });
}

function getAll() {
  return akeronService.make_get_request(`${section}`, {}).then((response) => {
    return response.companies || response.list || [];
  });
}

function remove(id) {
  return akeronService.make_delete_request(`${section}/${id}`, {});
}

function create(item) {
  const param = {
    name: item.name,
    idCompanyType: item.companyType.id,
  };
  return akeronService.make_post_request(`${section}`, param);
}

function update(item) {
  const param = {
    id: item.id,
    name: item.name,
    idCompanyType: item.companyType.id,
    isActive: item.isActive !== undefined ? item.isActive : true,
  };
  return akeronService.make_put_request(`${section}/${item.id}`, param);
}

export const companyService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
